module.exports = __webpack_public_path__ + "img/bespoke70_27.0bf348bb.jpg";